module.exports = __webpack_public_path__ + "static/media/interviewPreparation.7bc66d18.jpg";